import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/AuthContext";

const RegistrationRoute = ({ children }) => {
  const location = useLocation();
  const { user } = useAuth();

  console.log("user.idTipoStatusCliente", user.idTipoStatusCliente);
  console.log("location.pathname", location.pathname);
  if (user == null) {
    return <Navigate to="/Login" replace />;
  } else if (
    user.idTipoStatusCliente !== 6 &&
    location.pathname === "/ClienteLimiteOperacional"
  ) {
    console.log("entrou aquixx");
    return <Navigate to="/MinhaConta" replace />;
  } else return children;
};

export default RegistrationRoute;
